// extracted by mini-css-extract-plugin
export default {"root":"FBwMK","count-and-variation-tag":"_2FfG9","countAndVariationTag":"_2FfG9"};